import React from "react";
import RealizationOrderView from "./RealizationOrderView";
import useRealizationOrder from "./useRealizationOrder";

function RealizationOrder() {
  return <RealizationOrderView {...useRealizationOrder()} />;
}

export default RealizationOrder;
